import { UtilService } from 'app/_services/util.service';
import * as angular from 'angular';
import {
    FeatureToggles,
    FeatureTogglesResource
} from 'angular/resources/feature-toggles.resource';
import { mgoAngularWizard } from '../custom';

class WizardHostComponentCtrl implements ng.IController {
    public templateUrl: string;
    public wizardName: string;

    public wizard: mgoAngularWizard.Wizard<any>;
    public featureToggles: FeatureToggles;

    constructor(
        private WizardHandler: mgoAngularWizard.WizardHandler<any>,
        private utilService: UtilService,
        private featureTogglesResource: FeatureTogglesResource
    ) {}

    $onInit(): void {
        this.featureTogglesResource
            .getUrls()
            .subscribe(
                (featureToggles) => (this.featureToggles = featureToggles)
            );
    }

    $doCheck(): void {
        if (this.wizard) {
            return;
        }

        const wizard: mgoAngularWizard.Wizard<any> = this.WizardHandler.wizard(
            this.wizardName
        );

        if (wizard) {
            this.wizard = wizard;
            this.resetWizard();
        }
    }

    private resetWizard(): void {
        Object.keys(this.wizard.context).forEach(
            (key) => delete this.wizard.context[key]
        );
        this.wizard.context.data = {};
        this.wizard.context.data.wizardGuid = this.utilService.generateGuid();
    }
}

angular.module('app').component('pkpWizardHost', {
    controller: WizardHostComponentCtrl,
    template: `<ng-include src="$ctrl.templateUrl"></ng-include>`,
    bindings: {
        wizardName: '@',
        templateUrl: '@'
    }
});
